/**
 * Development-only console helpers. Production builds must not log to the customer browser.
 */

const isDev = process.env.NODE_ENV !== 'production';

export function devLog(...args) {
  if (!isDev) return;
  // eslint-disable-next-line no-console
  console.log(...args);
}

export function devWarn(...args) {
  if (!isDev) return;
  // eslint-disable-next-line no-console
  console.warn(...args);
}

export function devError(...args) {
  if (!isDev) return;
  // eslint-disable-next-line no-console
  console.error(...args);
}
